export enum TimeEntryBreakResponseTypeIds {
  OpportunityAndTaken = 100,
  OpportunityAndNotTaken = 200,
  NoOpportunity = 300,
}
